export enum AB_TESTS {
  PRO_REVIEWS_ON_VENUE = 'proReviewsOnVenue',
  PRO_REVIEWS_ON_OFFER = 'proReviewsOnOffer',
}
